import { WebStorageStateStore, type UserManagerSettings } from "oidc-client-ts";
import { appConfig } from "../appConfig";

export const STORAGE_PREFIX = "vcoidc.";
export const redirectStorageKey = `${STORAGE_PREFIX}redirectUri`;
const userStore = localStorage;

export const authConfig = {
  userStore: new WebStorageStateStore({ prefix: STORAGE_PREFIX, store: userStore }),
  authority: appConfig.env.AUTH_AUTHORITY,
  client_id: appConfig.env.AUTH_CLIENT_ID,
  redirect_uri: location.origin,
  scope: ["openid", "profile", "roles", "offline_access", "tenants", "email"].join(" "),
  post_logout_redirect_uri: location.origin,
  response_type: "code",
  response_mode: "query",
  loadUserInfo: true,
  automaticSilentRenew: true,
} satisfies UserManagerSettings;
